// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer{
    background: #000;
    color: #191919;   
}
.tail{
    padding-top: 2.40117rem;
    padding-bottom: 2rem;
    border-top: 1px solid #fff4 ; 
    
}

.tail img{
    height: 37px;
}

/* .tail a, .tail p{
    font-size: 0.75592rem;
    font-weight: 600;
} */

.tail .link-box, .tail {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tail .cr-box p{
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
     color: #fff;
     /* margin-left: 58px; */
}
.tail .cr-box h6{
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
     color: #fff;
     display: none;
}
/* .tail .media{
    margin-left: 75px;
} */
.tail .media button{
    background-color: transparent;
    height: 34px;
    border: none;
    transition: ease 0.1s;
}
.tail .media button img{
    height: 34px;
}
button{
    font-weight: 600;
  }


/* .tail .media button:hover{
    box-shadow: 0px 0px 8px 2px rgba(206, 236, 236, 0.822);
    border-radius: 30px;
    background-color: rgba(216, 243, 243, 0.5);
   } */

   .tail-container {
    display: flex;
    flex-direction: column;
}

.footer-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: auto;
}
.footer .scroll-top{
    margin-top: -6rem;
}
.footer .up-img{
    width: 70%;
}

.scroll-top-button {
    transform: rotate(180deg);
}
.footer-sec .media a{
    padding-right: 10px;
}
.footer-sec .media svg path{
    fill: #ffffff;
    transition: fill 0.8s ease;
}
.footer-sec .media svg:hover path{
    fill: #F9F39C ;

  }

@media (min-width:567px) and (max-width: 992px) {
    .footer-sec .media a{
        padding: 0;
    }
    
    .footer .main .main-col {
        border-right: none;
        padding-left:24px;
        padding-right: 24px;
    }
    .footer .main div{
        border-right: none
    }
    
    .footer ul li{
        font-size: 16px;
        width: 100%;
    }
    .footer ul li:first-child {
        font-size: 20px;
    }
    .footer ul{
        margin: 0;
        padding-top: 40px;
        padding-bottom: 40px;
    }
    
   .footer .link-box li:first-child{
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 0;
        line-height: 1.7;
    }
    .footer .link-box li{
        text-decoration: underline;
    }
    .tail .link-box, .tail {
        display:block;
        justify-content:center;
        align-items: center;
    }
    


.tail .cr-box p{
    font-size: 14px !important;
    line-height: 47px;
    margin-top: 1.3rem;
    margin-left: 0px;
}
.tail .cr-box span{
    display:block;
    text-align: center;
    font-size: 16px;
    line-height: 0px;
}
.media{
    margin: auto;
    margin-top: 2.5rem;
}
.tail .media{
    margin-top: 1rem;
    /* margin-left: 250px; */
}
.tail{
    padding-top: 2.40117rem;
    padding-bottom: 0rem;
    border-top: 1px solid #fff4 ; 
}
/* .tail .footer-sec{
    margin-left: 13px;
} */
.dest-contact{
    font-size: 15px !important;
}
   
  }
/* 
@media (min-width:577px) and (max-width: 768px) {
    .tail .link-box, .tail {
        display: flex;
    }
    .footer .main .main-col {
        border-right:unset
    }
    .social-box{
        width: 100px;
    }
    .social-box .col-md-6{
     margin-bottom: 20px;
    }
    .social-box img{
    padding-left: 20px;
    }
    .tail .img-box,.tail .cr-box{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
    }
    .tail .cr-box p{
        width: fit-content !important;
        font-size: 16px;
    }
  } */
  
   /*responssive for Mobile*/
  
   @media (max-width: 576px) {
    .tail .link-box, .tail {
        display: block;
    }

    .tail .cr-box p{
        width: fit-content !important;
        font-size: 14px;
        margin-top: 2.8rem;
        margin-bottom: 1.5rem;
        margin-left: 0px;
        text-align: left;
        line-height: 22px;
    }
    .tail .cr-box span{
        display:block;
        /* text-align: center; */
        font-size: 14px;
        line-height: 22px;
    }
    .hide{
        display: none;
    }
    .tail .media{
        margin-left: 0px;
        margin-top: 13px;
        display: flex;
    }
    .tail{
        text-align: left;
        padding-top: 2.40117rem;
        padding-bottom: 0rem;
        border-top: 0px solid #fff4 ; 
        width: 100%;
        
    }
    .footer .tail-line{
        border-top: 1px solid #fff4;
        width: 102%;
        margin-left: -3px;
      }
    
    .footer-sec{
        /* margin-left: -10px; */
        justify-content: left !important;
    }
    
  }
  @media (min-width:1200px){
    /* .tail .cr-box p{
         margin-left: 80px;
    } */
    .footer .img-box{
        position: relative;
        left: -3.6rem;
    }
    .tail{
        margin-left: 1rem;
        margin-right: 1rem;
        padding-left: 2rem;
        padding-right: 2rem;
        /* width: 87%; */
    }
    .footer .footer-sec{
        position: relative;
        left: 1.5rem;
    }

  }

  @media (max-width: 993px) {
    .footer-sec {
        justify-content: center;
    }
    
}

@media (min-width:1400px){
    .tail{
        /* margin-left: 6rem; */
        padding-left: 5rem;
        padding-right: 5rem;
        width: 99%;
    }
    .footer .img-box{
        position: relative;
        left: -4.9rem;
    }
    .footer .footer-sec{
        position: relative;
        left: 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/common-componets/Footer.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,4BAA4B;;AAEhC;;AAEA;IACI,YAAY;AAChB;;AAEA;;;GAGG;;AAEH;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;KACjB,WAAW;KACX,uBAAuB;AAC5B;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;KACjB,WAAW;KACX,aAAa;AAClB;AACA;;GAEG;AACH;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;EAClB;;;AAGF;;;;MAIM;;GAEH;IACC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,cAAc;;EAEhB;;AAEF;IACI;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,SAAS;QACT,iBAAiB;QACjB,oBAAoB;IACxB;;GAED;QACK,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;;;AAIJ;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,4BAA4B;AAChC;AACA;;GAEG;AACH;IACI,0BAA0B;AAC9B;;EAEE;AACF;;;;;;;;;;;;;;;;;;;;;;;;;;;KA2BK;;GAEF,yBAAyB;;GAEzB;IACC;QACI,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;QAClB,qBAAqB;QACrB,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,wBAAwB;QACxB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,uBAAuB;QACvB,oBAAoB;QACpB,4BAA4B;QAC5B,WAAW;;IAEf;IACA;QACI,2BAA2B;QAC3B,WAAW;QACX,iBAAiB;MACnB;;IAEF;QACI,wBAAwB;QACxB,gCAAgC;IACpC;;EAEF;EACA;IACE;;OAEG;IACH;QACI,kBAAkB;QAClB,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,YAAY;IAChB;;EAEF;;EAEA;IACE;QACI,uBAAuB;IAC3B;;AAEJ;;AAEA;IACI;QACI,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,YAAY;IAChB;AACJ","sourcesContent":[".footer{\r\n    background: #000;\r\n    color: #191919;   \r\n}\r\n.tail{\r\n    padding-top: 2.40117rem;\r\n    padding-bottom: 2rem;\r\n    border-top: 1px solid #fff4 ; \r\n    \r\n}\r\n\r\n.tail img{\r\n    height: 37px;\r\n}\r\n\r\n/* .tail a, .tail p{\r\n    font-size: 0.75592rem;\r\n    font-weight: 600;\r\n} */\r\n\r\n.tail .link-box, .tail {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.tail .cr-box p{\r\n    font-family: Poppins;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 14px;\r\n    letter-spacing: 0px;\r\n    text-align: center;\r\n     color: #fff;\r\n     /* margin-left: 58px; */\r\n}\r\n.tail .cr-box h6{\r\n    font-family: Poppins;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 14px;\r\n    letter-spacing: 0px;\r\n    text-align: center;\r\n     color: #fff;\r\n     display: none;\r\n}\r\n/* .tail .media{\r\n    margin-left: 75px;\r\n} */\r\n.tail .media button{\r\n    background-color: transparent;\r\n    height: 34px;\r\n    border: none;\r\n    transition: ease 0.1s;\r\n}\r\n.tail .media button img{\r\n    height: 34px;\r\n}\r\nbutton{\r\n    font-weight: 600;\r\n  }\r\n\r\n\r\n/* .tail .media button:hover{\r\n    box-shadow: 0px 0px 8px 2px rgba(206, 236, 236, 0.822);\r\n    border-radius: 30px;\r\n    background-color: rgba(216, 243, 243, 0.5);\r\n   } */\r\n\r\n   .tail-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.footer-button-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: auto;\r\n}\r\n.footer .scroll-top{\r\n    margin-top: -6rem;\r\n}\r\n.footer .up-img{\r\n    width: 70%;\r\n}\r\n\r\n.scroll-top-button {\r\n    transform: rotate(180deg);\r\n}\r\n.footer-sec .media a{\r\n    padding-right: 10px;\r\n}\r\n.footer-sec .media svg path{\r\n    fill: #ffffff;\r\n    transition: fill 0.8s ease;\r\n}\r\n.footer-sec .media svg:hover path{\r\n    fill: #F9F39C ;\r\n\r\n  }\r\n\r\n@media (min-width:567px) and (max-width: 992px) {\r\n    .footer-sec .media a{\r\n        padding: 0;\r\n    }\r\n    \r\n    .footer .main .main-col {\r\n        border-right: none;\r\n        padding-left:24px;\r\n        padding-right: 24px;\r\n    }\r\n    .footer .main div{\r\n        border-right: none\r\n    }\r\n    \r\n    .footer ul li{\r\n        font-size: 16px;\r\n        width: 100%;\r\n    }\r\n    .footer ul li:first-child {\r\n        font-size: 20px;\r\n    }\r\n    .footer ul{\r\n        margin: 0;\r\n        padding-top: 40px;\r\n        padding-bottom: 40px;\r\n    }\r\n    \r\n   .footer .link-box li:first-child{\r\n        font-size: 16px;\r\n        font-weight: 400;\r\n        margin-bottom: 0;\r\n        line-height: 1.7;\r\n    }\r\n    .footer .link-box li{\r\n        text-decoration: underline;\r\n    }\r\n    .tail .link-box, .tail {\r\n        display:block;\r\n        justify-content:center;\r\n        align-items: center;\r\n    }\r\n    \r\n\r\n\r\n.tail .cr-box p{\r\n    font-size: 14px !important;\r\n    line-height: 47px;\r\n    margin-top: 1.3rem;\r\n    margin-left: 0px;\r\n}\r\n.tail .cr-box span{\r\n    display:block;\r\n    text-align: center;\r\n    font-size: 16px;\r\n    line-height: 0px;\r\n}\r\n.media{\r\n    margin: auto;\r\n    margin-top: 2.5rem;\r\n}\r\n.tail .media{\r\n    margin-top: 1rem;\r\n    /* margin-left: 250px; */\r\n}\r\n.tail{\r\n    padding-top: 2.40117rem;\r\n    padding-bottom: 0rem;\r\n    border-top: 1px solid #fff4 ; \r\n}\r\n/* .tail .footer-sec{\r\n    margin-left: 13px;\r\n} */\r\n.dest-contact{\r\n    font-size: 15px !important;\r\n}\r\n   \r\n  }\r\n/* \r\n@media (min-width:577px) and (max-width: 768px) {\r\n    .tail .link-box, .tail {\r\n        display: flex;\r\n    }\r\n    .footer .main .main-col {\r\n        border-right:unset\r\n    }\r\n    .social-box{\r\n        width: 100px;\r\n    }\r\n    .social-box .col-md-6{\r\n     margin-bottom: 20px;\r\n    }\r\n    .social-box img{\r\n    padding-left: 20px;\r\n    }\r\n    .tail .img-box,.tail .cr-box{\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n        margin-bottom: 20px;\r\n    }\r\n    .tail .cr-box p{\r\n        width: fit-content !important;\r\n        font-size: 16px;\r\n    }\r\n  } */\r\n  \r\n   /*responssive for Mobile*/\r\n  \r\n   @media (max-width: 576px) {\r\n    .tail .link-box, .tail {\r\n        display: block;\r\n    }\r\n\r\n    .tail .cr-box p{\r\n        width: fit-content !important;\r\n        font-size: 14px;\r\n        margin-top: 2.8rem;\r\n        margin-bottom: 1.5rem;\r\n        margin-left: 0px;\r\n        text-align: left;\r\n        line-height: 22px;\r\n    }\r\n    .tail .cr-box span{\r\n        display:block;\r\n        /* text-align: center; */\r\n        font-size: 14px;\r\n        line-height: 22px;\r\n    }\r\n    .hide{\r\n        display: none;\r\n    }\r\n    .tail .media{\r\n        margin-left: 0px;\r\n        margin-top: 13px;\r\n        display: flex;\r\n    }\r\n    .tail{\r\n        text-align: left;\r\n        padding-top: 2.40117rem;\r\n        padding-bottom: 0rem;\r\n        border-top: 0px solid #fff4 ; \r\n        width: 100%;\r\n        \r\n    }\r\n    .footer .tail-line{\r\n        border-top: 1px solid #fff4;\r\n        width: 102%;\r\n        margin-left: -3px;\r\n      }\r\n    \r\n    .footer-sec{\r\n        /* margin-left: -10px; */\r\n        justify-content: left !important;\r\n    }\r\n    \r\n  }\r\n  @media (min-width:1200px){\r\n    /* .tail .cr-box p{\r\n         margin-left: 80px;\r\n    } */\r\n    .footer .img-box{\r\n        position: relative;\r\n        left: -3.6rem;\r\n    }\r\n    .tail{\r\n        margin-left: 1rem;\r\n        margin-right: 1rem;\r\n        padding-left: 2rem;\r\n        padding-right: 2rem;\r\n        /* width: 87%; */\r\n    }\r\n    .footer .footer-sec{\r\n        position: relative;\r\n        left: 1.5rem;\r\n    }\r\n\r\n  }\r\n\r\n  @media (max-width: 993px) {\r\n    .footer-sec {\r\n        justify-content: center;\r\n    }\r\n    \r\n}\r\n\r\n@media (min-width:1400px){\r\n    .tail{\r\n        /* margin-left: 6rem; */\r\n        padding-left: 5rem;\r\n        padding-right: 5rem;\r\n        width: 99%;\r\n    }\r\n    .footer .img-box{\r\n        position: relative;\r\n        left: -4.9rem;\r\n    }\r\n    .footer .footer-sec{\r\n        position: relative;\r\n        left: 1.5rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
